"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "#f7f4ee",
          color: "#15171b",
          fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
          padding: "24px",
        }}
      >
        <div style={{ maxWidth: "480px", textAlign: "center" }}>
          <h1 style={{ fontSize: "28px", margin: "0 0 12px", letterSpacing: "-0.02em" }}>
            Něco se pokazilo
          </h1>
          <p style={{ margin: "0 0 24px", color: "#5b564e", lineHeight: 1.75 }}>
            Omlouvám se, načtení stránky se nepodařilo. Zkuste to prosím znovu, nebo zavolejte na
            +420 605 477 849.
          </p>
          {error.digest ? (
            <p style={{ margin: "0 0 24px", fontSize: "13px", color: "#6e675b" }}>
              Kód chyby: {error.digest}
            </p>
          ) : null}
          <button
            type="button"
            onClick={reset}
            style={{
              border: "1px solid #b08a4a",
              borderRadius: "2px",
              background: "#b08a4a",
              color: "#101216",
              padding: "14px 30px",
              fontSize: "13px",
              fontWeight: 600,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Zkusit znovu
          </button>
        </div>
      </body>
    </html>
  );
}
